import React from 'react';

import {OutlinedInput, Select} from "@mui/material";
import {styled} from "@mui/material/styles";

import {ReactComponent as ArrowDouble} from "assets/img/arrow-double.svg";
import {black500, grey200, greyishBlue50, greyishBlue200, red500} from "assets/jss/main";

const StyledSelect = styled(Select)({
    height: '40px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    color: black500,
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'left',
    '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '16px',
        // 16px right padding + 16px icon + 8px gap between label and icon
        paddingRight: '40px !important'
    },
    '& fieldset': {
        borderColor: greyishBlue200
    },
    '&.Mui-disabled': {
        backgroundColor: grey200,
        '&& fieldset': {
            borderColor: 'transparent'
        },
        '& .MuiSelect-select': {
            color: greyishBlue200,
            WebkitTextFillColor: greyishBlue200
        },
        '& .MuiSelect-icon path': {
            stroke: greyishBlue200
        }
    },
    '& .MuiSelect-icon': {
        width: '16px',
        height: '16px',
        right: '16px',
        top: 'calc(50% - 8px)',
        'path': {
            stroke: black500
        }
    }
});

const menuPaperSx = {
    marginTop: '4px',
    borderRadius: '8px',
    border: `1px solid ${greyishBlue200}`,
    boxShadow: '0px 4px 22px 0px rgba(0, 0, 0, 0.04)',
    padding: '12px 8px',
    '& .MuiList-root': {
        padding: 'unset'
    },
    '& .MuiMenuItem-root': {
        height: '32px',
        padding: '8px',
        borderRadius: '8px',
        color: black500,
        fontSize: '14px',
        fontWeight: 400,
        '&:hover': {
            backgroundColor: greyishBlue50
        },
        '&.destructive': {
            color: red500
        }
    }
};

function ListingActionsSelect({children, ...props}) {
    return (
        <StyledSelect
            variant="standard"
            IconComponent={ArrowDouble}
            input={<OutlinedInput name="actions"/>}
            MenuProps={{PaperProps: {sx: menuPaperSx}}}
            {...props}
        >
            {children}
        </StyledSelect>
    );
}

export default ListingActionsSelect;
